import { OtherHorizontal } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';

import { Button } from '../../Button/Button';

import styles from './ThreeDotsButton.module.scss';
import { Props } from './ThreeDotsButton.types';

/** @deprecated use one of the following instead:
 * @example import { OtherHorizontal } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *          import { Button } from '@randstad-lean-mobile-factory/react-components-core';
 *
 *          // In 90% of cases
 *          <Button variant="tertiary" size="medium"><OtherHorizontal variant="fill" /></Button>
 *
 *          // In cases of a very large button
 *          <Button size="large" rounded><OtherHorizontal /></Button>
 */
export const ThreeDotsButton = ({ className, triggered, ...props }: Props) => {
  return (
    <Button
      variant="tertiary"
      selected={triggered}
      className={classnames(styles.button, className)}
      {...props}
    >
      <OtherHorizontal variant="fill" />
    </Button>
  );
};
